import { Navigate, Outlet, useLocation } from 'react-router';
import { useAppSelector } from '@/hooks';
import { selectIsAuthenticated, selectUserRole } from '@/features/auth';
import type { Role } from '@/models';
import { resumablePath } from './resumablePath';

export function ProtectedRoute(): React.JSX.Element {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const location = useLocation();
  if (!isAuthenticated) {
    const from = resumablePath(location.pathname) ? location : undefined;
    return <Navigate to="/login" state={from ? { from } : undefined} replace />;
  }
  return <Outlet />;
}

export function RoleRoute({ roles }: { roles: Role[] }): React.JSX.Element {
  const role = useAppSelector(selectUserRole);
  if (role !== null && !roles.includes(role)) return <Navigate to="/unauthorized" replace />;
  return <Outlet />;
}

export function GuestRoute(): React.JSX.Element {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  if (isAuthenticated) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}
